<div class="buy">
  <div class="buy__main">
    <div class="buy__step buy__payWith">
      <p class="buy__title">{{ 'buy.title1' | translate }}</p>
      <mat-form-field class="buy__ff" appearance="fill">
        <mat-select
          (selectionChange)="buyCoinWasSelected($event)"
          [(value)]="payWithCoin"
        >
          <mat-option value="BTC" class="notranslate"
            >BITCOIN</mat-option
          >
          <mat-option value="ETH" class="notranslate"
            >ETHER</mat-option
          >
          <!-- <mat-option value="BRL" disabled>REAIS</mat-option> -->
        </mat-select>
      </mat-form-field>
    </div>
    <div class="buy__step buy__howmuch">
      <p class="buy__title">{{ 'buy.title2' | translate }}</p>
      <form [formGroup]="buyFormGroup">
        <mat-form-field class="buy__ff" appearance="fill">
          <input
            class="text-right-align"
            matInput
            #spendInput
            [formControl]="spending"
            inputmode="decimal"
            [step]="stepIncrement"
            class="text-right-align"
            (keyup.enter)="evaluateInput(spendInput.value)"
            (blur)="evaluateInput(spendInput.value)"
          />
          <mat-hint>{{ 'buy.minValueHint' | translate }} {{ minAmount }} </mat-hint>
          <mat-error *ngIf="spending.invalid">
            {{ getSpendingErrorMsg() }}
          </mat-error>
        </mat-form-field>
      </form>
    </div>
    <div class="buy__step">
      <p class="buy__title notranslate">{{ 'buy.title3' | translate }}<span class="notranslate">(Soya Coins)</span></p>
      <p class="buy__total notranslate" [hidden]="!displayTotal">
        {{
          floor10(
            sub(purchaseAmount, multiply(pctFee, purchaseAmount)),
            -6
          )
        }}
        <span class="notranslate"> SOY</span>
      </p>
      <mat-hint [hidden]="!displayTotal" translate [translateParams]="{amount: floor10(multiply(pctFee, 100), -2)}"
        >buy.feeHint</mat-hint
      >
    </div>
  </div>

  <div class="result mb-lg">
    <div class="balance mr-lg">
      <div class="balance__buttons">
        <div class="balance__btn" (click)="inputPreset(0.25)">
          25%
        </div>
        <div class="balance__btn" (click)="inputPreset(0.5)">50%</div>
        <div class="balance__btn" (click)="inputPreset(0.75)">
          75%
        </div>
        <div class="balance__btn" (click)="inputPreset(1)">100%</div>
      </div>
      <div class="balance__info">
        <p class="balance__info--label">{{ 'buy.balanceTxt' | translate }}</p>
        <p
          [ngClass]="{
            'balance__info--value': true,
            'balance__info--blink': blinkBalance
          }"
        >
          {{ floor10(getBalance(payWithCoin), -6) }}
          {{ payWithCoin }}
        </p>
      </div>
    </div>
  </div>

  <div class="buy__final">
    <button
      class="btn"
      mat-flat-button
      color="primary"
      (click)="consumeBucket()"
      [disabled]="
        getBalance(payWithCoin) < minAmount ||
        spending.value > getBalance(payWithCoin)
      "
    >
    {{ 'buy.button1' | translate | uppercase }}
    </button>
  </div>
  <div
    class="blocked"
    [style.opacity]="spending.value > getBalance(payWithCoin) ? 1 : 0"
  >
    <p class="blocked__msg">{{ 'buy.mainError' | translate | uppercase }}</p>
  </div>
</div>
